var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag",style:('background-color:'+_vm.color)},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }